import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import type {
  JsonObject,
  UserSearchForAnsweringServiceQuery,
  UserSearchForAnsweringServiceResponseBody,
} from '@/app-package';

const searchForAnsweringService = async (
  params: UserSearchForAnsweringServiceQuery,
) => {
  const config: AxiosRequestConfig = {
    url: '/user/search/by_answering_user',
    method: 'get',
    params,
  };

  const { data } =
    await axios.request<JsonObject<UserSearchForAnsweringServiceResponseBody>>(
      config,
    );

  return data;
};

export default searchForAnsweringService;
